import * as types from 'prop-types';

export const FunnelFilterProps = {
  canShutWork: types.bool,
  order: types.object,
  setOrder: types.func,
  productGroup: types.object,
  setProductGroup: types.func,
  product: types.object,
  setProduct: types.func,
  negotiation: types.object,
  setNegotiation: types.func,
  clearFiltersHandler: types.func
}